import { defineStore } from "pinia"
import { HttpService } from "@/helpers/http-service"
import { CONSTANT } from "@/helpers/constant"
import type { JcPropertyGroup } from "@/types/jersey"

const httpService = new HttpService()

interface ListResponse {
  data: { total: number; page: number; limit: number; data: JcPropertyGroup[] }
}

interface FetchOptions {
  limit?: number
  page?: number
  includeOptions?: boolean
}

interface JcPropertyGroupsState {
  groups: JcPropertyGroup[]
  loading: boolean
}

export const useJcPropertyGroupsStore = defineStore({
  id: "jc.property.groups",
  state: (): JcPropertyGroupsState => ({
    groups: [],
    loading: false,
  }),
  actions: {
    async fetchGroups(options: FetchOptions = {}): Promise<boolean> {
      this.loading = true
      try {
        const params = {
          limit: options.limit ?? 500,
          page: options.page ?? 1,
          includeOptions: options.includeOptions ?? false,
        }
        const result = (await httpService.get(CONSTANT.API.JC_FILTER.PROPERTY_GROUP.LIST, params)) as ListResponse
        this.groups = result?.data?.data ?? []
        return true
      } catch (error) {
        console.error("Failed to fetch property groups", error)
        this.groups = []
        return false
      } finally {
        this.loading = false
      }
    },
  },
})
